module.exports = __webpack_public_path__ + "static/media/balanceSheet.9c8ae4c8.svg";